<template>
    <div class="short-channel-order-form-page-2">
        <div class="d-flex align-items-center mb-4">
            <div class="flex-fill">
                <div class="alert alert-info text-center mb-0">
                    La commande n'est pas encore enregistrée, n'oubliez pas de valider.
                </div>
            </div>
            <div class="ml-3">
                <slot name="submitButton" :on-click-next="onClickNext"></slot>
            </div>
        </div>

        <div class="form-group row">
            <label for="customer" class="col-md-3 col-form-label">Groupement de clients</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="customer" :value="customer.name" readonly>
            </div>
        </div>
        <div class="form-group row">
            <label for="deliveryDate" class="col-md-3 col-form-label">Date de livraison</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="deliveryDate" :value="formattedDeliveryDate" readonly>
            </div>
        </div>
        <div class="form-group row">
            <label for="endPreparationDate" class="col-md-3 col-form-label">Date de fin de préparation</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="endPreparationDate" :value="formattedEndPreparationDate" readonly>
            </div>
        </div>
        <div class="form-group row">
            <label for="closingDate" class="col-md-3 col-form-label">Date de fermeture des commandes</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="closingDate" :value="formattedClosingDate" readonly>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-md-3 col-form-label" for="image">Image</label>
            <div class="col-md-9">
                <img
                    v-if="lImageSrc"
                    width="150"
                    :src="lImageSrc"
                />
                <img
                    v-else-if="order && order.logo_url"
                    width="150"
                    :src="order.logo_url"
                />
                <template v-else>
                    Aucune image sélectionnée
                </template>
            </div>
        </div>
        <div class="form-group row">
            <label for="description" class="col-md-3 col-form-label">Description</label>
            <div class="col-md-9">
                <input type="text" class="form-control-plaintext" id="description" :value="description" readonly>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <slot name="alerts"></slot>

                <slot name="errors"></slot>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <hr>

                <button type="button" class="btn btn-outline-dark float-left" @click="onClickBack" :disabled="loading || sending">
                    <i class="fas fa-chevron-left"></i> Retour
                </button>

                <slot name="submitButton" :on-click-next="onClickNext"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import ErrorsZone from "../ErrorsZone"

import {momentDay} from "../../moment-with-helpers"
import {readFileAsDataURL} from "../../helpers";

export default {
    components: {
        ErrorsZone
    },

    props: {
        order: {
            type: Object,
            required: false,
        },
        customer: {
            type: Object,
            required: true,
        },
        deliveryDate: {
            type: Object,
            required: true,
        },
        endPreparationDate: {
            type: Object,
            required: true,
        },
        closingDate: {
            type: Date,
            required: true,
        },
        image: {
            type: File,
            required: false,
            default: null,
        },
        description: {
            type: String,
            required: false,
        },
        authorizationToken: {
            type: String,
            required: false,
            default: '',
        },
        errors: {
            required: false,
        },
        loading: {
            type: Boolean,
            required: true,
        },
        sending: {
            type: Boolean,
            required: true,
        },
    },

    data() {
        return {
            lImageSrc: null,
        };
    },

    mounted() {
        this.loadImagePreview();
        this.$emit('mounted');
    },

    methods: {
        onClickBack() {
            this.$emit('back');
        },

        onClickNext() {
            this.$emit('submit');
        },

        async loadImagePreview() {
            if (this.image instanceof File) {
                this.lImageSrc = await readFileAsDataURL(this.image);
            } else {
                this.lImageSrc = null;
            }
        },
    },

    watch: {
        image() {
            this.loadImagePreview();
        },
    },

    computed: {
        canClickNext() {
            return true;
        },

        formattedDeliveryDate() {
            return momentDay(this.deliveryDate.date).format('dddd Do MMMM YYYY');
        },

        formattedClosingDate() {
            return momentDay(this.closingDate).format('dddd Do MMMM YYYY');
        },

        deliveryDateYmd() {
            return momentDay(this.deliveryDate.date).format('YYYY-MM-DD');
        },

        formattedEndPreparationDate() {
            return momentDay(this.endPreparationDate.date).format('dddd Do MMMM YYYY');
        },

        endPreparationDateYmd() {
            return momentDay(this.endPreparationDate.date).format('YYYY-MM-DD');
        },
    }
}
</script>
